module.exports = __webpack_public_path__ + "img/antes_despues_91.a2adb163.png";